import { For, createEffect } from "solid-js";
import { requireReportBrowser } from "./report-browser-context";
import './side-nav.css'
import { ReportGroup } from "st-app/api";

let currScroll: number | null = null;

export default function SideNav() {
  const reportBrowser = requireReportBrowser()!

  let container: HTMLDivElement = undefined!;

  const onClickNavItem = (e: MouseEvent, group: ReportGroup) => {
    currScroll = container.scrollTop || container.parentElement!.scrollTop
    
   reportBrowser.setSelectedGroup(group);

    if (reportBrowser.state.isInCarousel) {
      reportBrowser.toggleCarousel(false)
      reportBrowser.toggleCarousel(true)
    }
  }

  createEffect(() => {
    if (reportBrowser.selectedGroup()) {
      const idx = reportBrowser.state.groups.indexOf(reportBrowser.selectedGroup()!)

      if (container) {
        if (currScroll) {
          container.scrollTo({ top: currScroll })
          container.parentElement!.scrollTo({ top: currScroll })
        } else {
          const item = container.children.item(idx)
          if (item) {
            //@ts-ignore
            if (item.scrollIntoViewIfNeeded) {
              //@ts-ignore
              item.scrollIntoViewIfNeeded();
            } else {
              item.scrollIntoView();
            }
          }
        }

      }
    }
  })

  return (
      <div class="report-browser-side-nav" ref={container}>
          <For each={reportBrowser.state.groups}>{(group) => (
              <div
                  use:tooltip={group.description}
                  onClick={(e) => onClickNavItem(e, group)}
                  class="report-browser-side-nav-item"
                  classList={{ 'selected': reportBrowser.selectedGroup()?.description === group.description }}
              >
                  <img src={group.groupImage}></img>
              </div>
          )}</For>
      </div>
  )
}